/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React,{useState} from 'react'
import CategoryToolTip from '../CategoryToolTip';
import { AddressDrop } from './AddressDrop';

export default function AddressChangeModal({prod,selectedAddressObj,setselectedAddressObj,addressDropdown}) {
    const [hoverId, sethoverId] = useState('');

    return (
        <div className="modal-dialog modal-dialog-centered relative lg:max-w-[761px] lg:min-w-[761px] w-full px-3 mx-auto pointer-events-none">
            <div className="modal-content border-none shadow-lg relative flex flex-col pointer-events-auto w-full bg-white bg-clip-padding rounded-md outline-none text-current md:px-[32px] sm:px-5 px-3.5 sm:pt-[32px] pt-5 sm:pb-6 pb-5">
                <div className="modal-header flex flex-shrink-0 items-center justify-center rounded-t-md relative">
                    <h5 className="sm:text-xl text-lg font-semibold leading-normal text-[#090406]" id="exampleModalScrollableLabel">
                        Change Address
                    </h5>
                    <button type="button" className="absolute top-0 right-0" data-bs-dismiss="modal" aria-label="Close">
                        <img src="images/Icon-ionic-ios-close.svg" alt="" />
                    </button>
                </div>
                <div className="modal-body relative sm:pt-7 pt-3">
                    <div className="rounded-lg bg-[#FFFFFF] shadow-s7 px-4 pb-5 pt-4 relative w-full">
                        <div className="flex flex-wrap">
                            <div className="lg:w-[80%] w-full pt-2">
                                <div className="flex">
                                    <div>
                                        <div>
                                            <p className="sm:text-xl text-base font-bold text-[#090406] pr-3">{prod?.MODEL_DESCRIPTION || `${prod?.DESCRIPTION.length > 20 ? `${prod.DESCRIPTION.slice(0,20)}...`:`${prod.DESCRIPTION}`}`}<span className="text-xs font-semibold text-[#FFFFFF] bg-[#44445E] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1 ml-2.5">{prod?.MAIN_CATEGORY}</span></p>
                                        </div>
                                        <p className="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1"><span>Product Code: {prod?.CONCATENATED_SEGMENTS}</span><span className="sm:px-4 px-2">|</span><span>AWS Classification: {prod?.AWS_CLASSIFICATION}</span></p>
                                        <div className="mt-2 flex sm:items-center items-baseline sm:flex-row flex-col">
                                            <div className="flex sm:border-r sm:border-[#707070] sm:pr-[6px] w-fit items-center">
                                                <p className="text-xs font-semibold text-[090406]">Category</p>
                                                <p className="text-xs3 font-semibold text-white px-1 bg-[#555259] rounded-[3px] w-fit mx-1.5">{prod?.DELIVERY_LEAD_TIME}</p>
                                                <button  >
                                                    <img src="images/info_icon.svg" alt="icon" className="cursor-pointer w-[10px]" onMouseEnter={()=>{
                                                        setTimeout(() => {
                                                            sethoverId(prod.INVENTORY_ITEM_ID)
                                                        }, 1000);
                                                    }} onMouseLeave={()=>{
                                                        setTimeout(() => {
                                                            sethoverId('')
                                                        }, 2000);
                                                    }}/>
                                                </button>
                                                {hoverId=== prod.INVENTORY_ITEM_ID &&(
                                                    <CategoryToolTip hover={hoverId=== prod.INVENTORY_ITEM_ID}/>
                                                )}
                                               
                                            </div>
                                            <p className="text-xs3 font-semibold text-[#808285] sm:px-[6px] sm:border-r sm:border-[#707070] sm:pt-0 pt-1">Expected Dispatch: <span className="font-bold text-[#555259]">14/06/2022</span></p>
                                            <p className="text-xs3 font-semibold text-[#808285] sm:pl-[6px] sm:pt-0 pt-1">Method of Packing: <span className="font-bold text-[#555259]">Box Packing</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-full pb-2 pt-2.5 rounded-lg flex flex-wrap justify-start xl:mr-4">
                            <div className="pr-2 border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Standard Pack Size</p>
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">1 kg</p>
                            </div>
                            <div className="px-2 sm:border-r border-[#CECECE] xl:w-auto sm:w-1/3 w-1/2">
                                <p className="text-xs font-semibold text-[#808285]">Size</p>
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">22 mm x 2 mm</p>
                            </div>
                            <div className="sm:pl-2 pt-2 sm:pt-0">
                                <p className="text-xs font-semibold text-[#808285]">Quantity</p>
                                <p className="sm:text-xs6 text-sm font-semibold text-[#555259]">10 kg</p>
                            </div>
                        </div>
                        <div>
                            <div className="flex flex-wrap -mx-2.5 mt-2">
                                <div className="px-2.5 lg:w-1/2 w-full">
                                    <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Billing address</p>
                                    <div className="dropdown relative">
                                        <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-[108px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                            <img src="images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                                        </button>
                                        <AddressDrop 
                                            type="billing_address"
                                            prod={prod}
                                            list={addressDropdown}
                                            selectedAddressObj={selectedAddressObj}
                                            setselectedAddressObj={setselectedAddressObj}/>
                                    </div>
                                </div>
                                <div className="px-2.5 lg:w-1/2 w-full lg:mt-0 mt-3">
                                    <p className="mb-1.5 text-xs13 font-semibold text-[#808285]">Shipping address</p>
                                    <div className="dropdown relative">
                                        <button type="button" id="s1" data-bs-toggle="dropdown" aria-expanded="false" className="dropdown-to h-[108px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5">
                                            <img src="images/chevron-red-down1.svg" alt="icon" className="absolute top-1/2 right-5" />
                                        </button>
                                        <AddressDrop type="shipping_address" 
                                            prod={prod}
                                            list={addressDropdown}
                                            selectedAddressObj={selectedAddressObj}
                                            setselectedAddressObj={setselectedAddressObj} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="pt-[22px] flex justify-center">
                        <button type="button" className="w-full sm:w-[306px] sm:py-3.5 py-2 rounded-lg bg-[#555259] sm:text-lg text-base font-semibold text-[#FFFFFF]" data-bs-dismiss="modal" aria-label="Close">
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
